module.exports = __webpack_public_path__ + "img/icon_wxz.f02ee94b.png";